export default function Datenschutz() {
  return (
    <section id="datenschutz" className="py-20 px-6 bg-gray-50 border-t border-gray-200">
      <div className="max-w-5xl mx-auto">
        <h2 className="font-serif text-3xl md:text-4xl text-gray-900 mb-10 tracking-tight">
          Datenschutzerklärung
        </h2>
        <div className="space-y-8 text-sm text-gray-600 font-light leading-relaxed">

          <div>
            <h3 className="font-medium text-gray-800 text-base mb-2">1. Verantwortlicher</h3>
            <p>Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:</p>
            <div className="mt-2 pl-3 border-l-2 border-amber-400 space-y-1">
              <p>Paula Schröter</p>
              <p>Laib und Liebe Catering</p>
              <p>Dobenaustraße 64, 08523 Plauen</p>
              <p>Telefon: <a href="tel:015752379870" className="hover:text-amber-600 transition-colors cursor-pointer">015752379870</a></p>
              <p>E-Mail: <a href="mailto:laibundliebe-catering@freenet.de" className="hover:text-amber-600 transition-colors cursor-pointer">laibundliebe-catering@freenet.de</a></p>
            </div>
          </div>

          <div>
            <h3 className="font-medium text-gray-800 text-base mb-2">2. Erhebung und Verarbeitung personenbezogener Daten</h3>
            <p>Wir erheben personenbezogene Daten nur, wenn Sie uns diese im Rahmen einer Kontaktaufnahme oder Anfrage freiwillig mitteilen. Dies umfasst insbesondere:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 pl-2">
              <li>Name und Vorname</li>
              <li>E-Mail-Adresse</li>
              <li>Telefonnummer</li>
              <li>Angaben zum gewünschten Event (Datum, Gästeanzahl, Angebot)</li>
              <li>Freitextnachrichten</li>
            </ul>
            <p className="mt-2">Diese Daten werden ausschließlich zur Bearbeitung Ihrer Anfrage und zur Vertragserfüllung verwendet.</p>
          </div>

          <div>
            <h3 className="font-medium text-gray-800 text-base mb-2">3. Rechtsgrundlage der Verarbeitung</h3>
            <p>Die Verarbeitung Ihrer Daten erfolgt auf Grundlage von:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 pl-2">
              <li><strong>Art. 6 Abs. 1 lit. b DSGVO</strong> – zur Erfüllung eines Vertrages oder vorvertraglicher Maßnahmen</li>
              <li><strong>Art. 6 Abs. 1 lit. f DSGVO</strong> – zur Wahrung berechtigter Interessen (z. B. Beantwortung von Anfragen)</li>
              <li><strong>Art. 6 Abs. 1 lit. a DSGVO</strong> – auf Grundlage Ihrer Einwilligung, sofern diese erteilt wurde</li>
            </ul>
          </div>

          <div>
            <h3 className="font-medium text-gray-800 text-base mb-2">4. Speicherdauer</h3>
            <p>Ihre personenbezogenen Daten werden nur so lange gespeichert, wie es für die Erfüllung des jeweiligen Zwecks erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen. Nach Wegfall des Zwecks oder Ablauf der gesetzlichen Fristen werden die Daten gelöscht. Handels- und steuerrechtliche Aufbewahrungsfristen betragen in der Regel 6 bis 10 Jahre.</p>
          </div>

          <div>
            <h3 className="font-medium text-gray-800 text-base mb-2">5. Weitergabe von Daten</h3>
            <p>Eine Weitergabe Ihrer personenbezogenen Daten an Dritte erfolgt grundsätzlich nicht, es sei denn, dies ist zur Vertragserfüllung erforderlich (z. B. Lieferanten) oder wir sind gesetzlich dazu verpflichtet. Alle eingesetzten Dienstleister sind vertraglich zur Einhaltung der DSGVO verpflichtet.</p>
          </div>

          <div>
            <h3 className="font-medium text-gray-800 text-base mb-2">6. Cookies und Website-Analyse</h3>
            <p>Diese Website verwendet keine Tracking-Cookies und keine Analyse-Tools von Drittanbietern. Es werden lediglich technisch notwendige Cookies eingesetzt, die für den Betrieb der Website erforderlich sind. Eine Einwilligung ist hierfür nicht erforderlich (Art. 6 Abs. 1 lit. f DSGVO).</p>
          </div>

          <div>
            <h3 className="font-medium text-gray-800 text-base mb-2">7. Ihre Rechte als betroffene Person</h3>
            <p>Sie haben gemäß DSGVO folgende Rechte:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 pl-2">
              <li><strong>Auskunftsrecht</strong> (Art. 15 DSGVO): Sie können Auskunft über Ihre gespeicherten Daten verlangen.</li>
              <li><strong>Berichtigungsrecht</strong> (Art. 16 DSGVO): Sie können die Berichtigung unrichtiger Daten verlangen.</li>
              <li><strong>Löschungsrecht</strong> (Art. 17 DSGVO): Sie können die Löschung Ihrer Daten verlangen, sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen.</li>
              <li><strong>Einschränkung der Verarbeitung</strong> (Art. 18 DSGVO): Sie können die Einschränkung der Verarbeitung verlangen.</li>
              <li><strong>Datenübertragbarkeit</strong> (Art. 20 DSGVO): Sie können Ihre Daten in einem strukturierten Format erhalten.</li>
              <li><strong>Widerspruchsrecht</strong> (Art. 21 DSGVO): Sie können der Verarbeitung Ihrer Daten widersprechen.</li>
              <li><strong>Widerruf der Einwilligung</strong> (Art. 7 Abs. 3 DSGVO): Eine erteilte Einwilligung kann jederzeit widerrufen werden.</li>
            </ul>
            <p className="mt-2">Zur Ausübung Ihrer Rechte wenden Sie sich bitte an: <a href="mailto:laibundliebe-catering@freenet.de" className="hover:text-amber-600 transition-colors cursor-pointer">laibundliebe-catering@freenet.de</a></p>
          </div>

          <div>
            <h3 className="font-medium text-gray-800 text-base mb-2">8. Beschwerderecht bei der Aufsichtsbehörde</h3>
            <p>Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen Daten zu beschweren. Die zuständige Aufsichtsbehörde für Sachsen ist:</p>
            <div className="mt-2 pl-3 border-l-2 border-amber-400 space-y-1">
              <p className="font-medium text-gray-700">Sächsischer Datenschutzbeauftragter</p>
              <p>Devrientstraße 5, 01067 Dresden</p>
              <p>Telefon: +49 351 85471 101</p>
              <p>E-Mail: <a href="mailto:saechsdsb@slt.sachsen.de" className="hover:text-amber-600 transition-colors cursor-pointer">saechsdsb@slt.sachsen.de</a></p>
            </div>
          </div>

          <div>
            <h3 className="font-medium text-gray-800 text-base mb-2">9. Datensicherheit</h3>
            <p>Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre Daten gegen zufällige oder vorsätzliche Manipulationen, Verlust, Zerstörung oder den Zugriff unberechtigter Personen zu schützen. Unsere Sicherheitsmaßnahmen werden entsprechend der technologischen Entwicklung fortlaufend verbessert.</p>
          </div>

          <div>
            <h3 className="font-medium text-gray-800 text-base mb-2">10. Aktualität dieser Datenschutzerklärung</h3>
            <p>Diese Datenschutzerklärung ist aktuell gültig und hat den Stand Januar 2025. Durch die Weiterentwicklung unserer Website oder aufgrund geänderter gesetzlicher bzw. behördlicher Vorgaben kann es notwendig werden, diese Datenschutzerklärung zu ändern.</p>
          </div>

          <p className="text-xs text-gray-400 pt-4 border-t border-gray-100">Stand: Januar 2025 · Laib und Liebe Catering, Paula Schröter</p>
        </div>
      </div>
    </section>
  );
}
